import "./amplify_setup.js";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { EbbnenWrapper } from "./App";

/* eslint-disable */
import i18n from "./i18n";
/* eslint-disable */
import { I18nextProvider } from "react-i18next";
import MultiUserAppWrapper from "./components/multiuser/MultiUserAppWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <MultiUserAppWrapper>
    <EbbnenWrapper>
      <App />
    </EbbnenWrapper>
  </MultiUserAppWrapper>,
  // </React.StrictMode>,
);
